// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function RaCreate(theme): object {
  return {
    RaCreate: {
      styleOverrides: {
        root: {
          '& .RaCreate-noActions': {
            marginTop: 0,
          },
        },
      },
    },
  }
}
